<template>
    <div v-if="visible" id="pm-welcome-dialog" :class="height < 650 ? 'pm-welcome-dialog-small-screen' : ''">
        <div id="pm-welcome-dialog-content"  :style="dialogStyle">
            <div v-touch="{ left: () => swipe('left'), right: () => swipe('right')}" style="position: relative; height: 100%; display: flex; flex-direction: column; padding: 0">
                <div style="flex-grow: 1; position: relative; display: flex; overflow: hidden;">
                    <transition :name="transitionDirection" leave-absolute group>
                        <div v-for="(step, stepIdx) in steps" v-if="stepIdx === currentStep" :key="stepIdx" style="display: flex; min-height: 100%; flex-direction: column; flex-grow: 1;">
                            <div style="flex-grow: 1; " v-if="!$slots['step' + (stepIdx+1)]">
                                <div id="pm-welcome-dialog-img" v-if="step.img" :style="{backgroundImage: 'url('+step.img+')', height: step.imgHeight ? step.imgHeight+'px' : '230px'}" style="background: #fff; background-size: contain; background-repeat: no-repeat; background-position: center; margin-bottom: 32px; width: 100%; margin: 50px 0;"></div>
                                <div style="padding: 0 32px; text-align: center; flex-grow: 0; align-items: center; justify-content: center;">

                                    <template v-if="step.title">
                                        <div class="roboto bold--text blue--text" style="line-height: 1.2; margin-top: 16px; font-size: 28px" v-html="step.title">
                                        </div>
                                        <br>
                                    </template>
                                    <p class="onboarding-step-description" style="line-height: 1.3; font-size: 15px; margin-bottom: 8px;" v-html="step.description" />
                                    <pm-welcome-screen-video style="margin: 8px -32px 40px -32px;" @close="close" v-if="step.videoSrc" :src="step.videoSrc" :name="step.videoName" />

                                    <div style="margin-top: 24px; display: flex; align-items: center; flex-direction: column;" v-if="step.buttons">
                                        <div @click="handleBtnClick(btn)" v-for="btn in step.buttons" :class="btn.class" class="onboarding-button">
                                            {{ btn.text }}
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div @click="close" style="padding: 16px 32px 24px 32px; color: #888; font-size: 12px;" v-if="steps[currentStep].skipBtn" v-html="steps[currentStep].skipBtn">
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .onboarding-button {
        width: 100%;
        max-width: 250px;
        border-radius: 28px;
        font-size: 16px;
        padding: 14px 10px;
        margin: 8px 0;
        line-height: 1;
        text-transform: uppercase;
        font-weight: 600;
    }
    .pm-welcome-dialog-small-screen #pm-welcome-dialog-img {
        max-height: 180px!important;
        margin-top: 30px!important;
        margin-bottom: 12px!important;
    }
    .onboarding-step-description {
        color: #444;
    }
    .onboarding-step-description b {
        text-shadow: 0.25px 0.25px 0 #000;
        color: #000;
    }

    .onboarding-button.primary {
        color: #fff;
    }

    .onboarding-button.normal {
        width: 100%;
        max-width: 250px;
        border-radius: 28px;
        font-size: 14px;
        padding: 12px 10px;
        box-shadow: none!important;
        border: 1px solid rgb(25, 118, 210);
        color: rgb(25, 118, 210);
        background: none!important;
    }

    #pm-welcome-dialog b {
        font-weight: 600;
    }

    #pm-welcome-dialog {
        position: fixed;
        z-index: 9999;
        padding: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0,0,0,.5);
        backdrop-filter: blur( 4px );
        -webkit-backdrop-filter: blur( 4px );
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    #pm-welcome-dialog-content {
        background: #fff;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 5px 5px 15px rgba(0,0,0,.3);
        flex-grow: 0;
        max-width: 500px;
        max-height: 630px;
        width: 100%;
        height: 100%;
        text-align: center;
        display: inline-block;
        font-size: 14px;
    }
</style>
<script>
import SvgTouch from "../svg/touch";
import SvgPlay from "../svg/play";
import PmWelcomeScreenVideo from "../core/pm-welcome-screen-video";
export default {
    components: {
        SvgTouch,
        SvgPlay,
        PmWelcomeScreenVideo,
    },
    props: {
        steps: {

        },
        dialogStyle: {},
    },
    data() {
        return ({
            visible: true,
            currentStep: 0,
            transitionDirection: "pm-fade-swipe-left",
            height: window.innerHeight,
        });
    },
    created() {

    },
    mounted() {
        this.onStepMounted();
    },
    watch: {
        currentStep(current, prev) {
            if (current < prev) this.transitionDirection = "pm-fade-swipe-right";
            else this.transitionDirection = "pm-fade-swipe-left";
            if (this.currentStep >= this.steps.length) {
                this.currentStep = this.steps.length - 1;
                this.visible = false;
            }

            this.onStepMounted();
        },
    },
    methods: {
        onStepMounted() {
            if (!this.visible) return; // prevent duplicate calls on hide
            if (typeof this.steps[this.currentStep].mounted === "function") {
                this.steps[this.currentStep].mounted();
            }
        },
        close() {
            this.$nextTick(()=>{
                this.visible = false;
            });
        },
        nextStep() {
            this.currentStep++;
        },
        handleClick() {
            if (this.currentStep < this.steps.length-1) this.currentStep++;
        },
        handleBtnClick(btn) {
            btn.click(this);
        },
        swipe(direction) {
            // if (direction === "left") {
            //     if (this.currentStep < this.steps.length-1) this.currentStep++;
            // }
            // if (direction === "right") {
            //     if (this.currentStep > 0) this.currentStep--;
            // }
        },
    },
};
</script>
